// extracted by mini-css-extract-plugin
export default {"category__card":"category-card_category__card__9vKHG","category__title":"category-card_category__title__XA5+X","category__value":"category-card_category__value__dVSaA"};